import {
  useGetTimeRegistrationAccuracyForHomeWidget,
  GET_TIME_REGISTRATION_KEY,
} from '@legacy/apis/timeRegistrationAccuracyAPI';
import WidgetWithoutChart from '../WidgetWithoutChart';

const TimeAccuracyWidget = () => {
  const {
    isError: isTimeAccuracyError,
    isLoading: isTimeAccuracyLoading,
    informationList: timeAccuracyInformationList,
  } = useGetTimeRegistrationAccuracyForHomeWidget('weekly');

  return (
    <WidgetWithoutChart
      queryKey={GET_TIME_REGISTRATION_KEY}
      relId="RegistrationAccuracy"
      informationList={timeAccuracyInformationList}
      isError={isTimeAccuracyError}
      isLoading={isTimeAccuracyLoading}
    />
  );
};

export default TimeAccuracyWidget;
